import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { APP_VERSION, formatBuildDate } from "@/lib/build-info";

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-cream-50 text-plum-900">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-[13px] font-semibold text-plum-700/70 hover:text-plum-700 mb-8" data-testid="legal-back">
          <ArrowLeft size={14} /> Retour à l&apos;accueil
        </Link>
        <h1 className="heading-display text-3xl sm:text-4xl mb-2">Mentions légales</h1>
        <p className="text-[13px] text-plum-700/55 mb-10">Version {APP_VERSION} · mise à jour le {formatBuildDate()}</p>

        <section className="space-y-8 text-[15px] leading-relaxed text-plum-700/85">
          <div>
            <h2 className="font-display font-bold text-lg text-plum-900 mb-2">Éditeur du site</h2>
            <p>
              Plateforme « Istres &amp; Moi » éditée par la <strong>Mairie d&apos;Istres</strong>.<br />
              Hôtel de Ville · Place de l&apos;Hôtel de Ville · 13800 Istres.<br />
              Directeur de la publication : Monsieur le Maire d&apos;Istres.
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-plum-900 mb-2">Conception &amp; développement</h2>
            <p>
              Site conçu et développé par <strong className="text-pink-600">BESSON SOLUTIONS</strong>.
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-plum-900 mb-2">Hébergement</h2>
            <p>Plateforme hébergée sur un cloud sécurisé certifié RGPD.</p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-plum-900 mb-2">Propriété intellectuelle</h2>
            <p>
              Les contenus présents sur Istres &amp; Moi (textes, images, logos) sont la propriété de la Mairie d&apos;Istres et de ses partenaires. Toute reproduction non autorisée est interdite.
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-plum-900 mb-2">Contact</h2>
            <p>Pour toute question relative à l&apos;application, contactez la mairie via la rubrique « Remontées » de la plateforme.</p>
          </div>
        </section>
      </div>
    </div>
  );
}
